import ZodConfig from 'constants/zodConfig'
import {z} from 'zod'

const forgotPasswordField = {
    email: {
        name: 'email',
        rules: {required: true},
        variant: 'standard',
        type: 'email',
    },
}

const resetPasswordField = {
    password: {
        name: 'password',
        rules: {required: true},
        variant: 'standard',
        type: 'password',
    },
    confirmPassword: {
        name: 'confirmPassword',
        rules: {required: true},
        variant: 'standard',
        type: 'password',
    },
}

const resetPasswordFieldValidation = z.object({
    password: ZodConfig.string().min(6, {message: 'password'}),
    confirmPassword: ZodConfig.string().min(6, {message: 'confirmPassword'}),
})
const forgotPasswordFieldValidation = z.object({
    email: ZodConfig.string().email({message: 'email'}),
})

export {
    forgotPasswordField,
    forgotPasswordFieldValidation,
    resetPasswordFieldValidation,
    resetPasswordField,
}
